import { useEffect, useState } from 'react'

import { ProfinderLog } from '@engine/models/admin'

import { ActivityTimeline } from '#components/ActivityTimeline'
import { ExpandableJsonPanel } from '#components/ExpandableJsonPanel'
import { KeyValueDisplay, KeyValueItem } from '#components/KeyValueDisplay'
import { formatDateTime } from '#utils/format'

import { ProfinderStatusBadge } from './ProfinderStatusBadge'
import { ProfinderTransactions } from './ProfinderTransactions'

interface ProfinderLogDetailsProps {
  log?: ProfinderLog
}

const ProfinderLogDetails = ({ log }: ProfinderLogDetailsProps) => {
  const [trace, setTrace] = useState<string | undefined>(undefined)

  // Extract traceId from log's requestId or payload
  useEffect(() => {
    if (!log) {
      setTrace(undefined)
      return
    }

    setTrace(log.trace)
  }, [log])

  if (!log) {
    return null
  }

  const { refNums, reason, reasonDetail, status, externalId } = log.data

  const loadId = refNums.find(r => r.type === 'loadNum')?.value || externalId
  const items: KeyValueItem[] = [
    {
      label: 'Load#',
      value: loadId,
    },
    {
      label: 'Result',
      value: <ProfinderStatusBadge status={status} />,
    },
    {
      label: 'Timestamp',
      value: formatDateTime(log.timestamp),
    },
    {
      label: 'Reason',
      value: reason || '-',
    },
    {
      label: 'Reason Detail',
      value: reasonDetail || '-',
    },
    {
      label: 'Request ID',
      value: log.data.requestId || '-',
    },
  ]

  return (
    <div className="space-y-6">
      <KeyValueDisplay items={items} className="mt-4" />
      <ExpandableJsonPanel data={log.data} />
      {trace && <ProfinderTransactions trace={trace} />}
      {externalId && (
        <div className="mt-6">
          <ActivityTimeline
            externalId={externalId}
            emptyMessage="No traces or request logs found for this profinder log."
          />
        </div>
      )}
    </div>
  )
}

export { ProfinderLogDetails }
